<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none">
    <g clip-path="url(#clip0_40002927_18004)">
      <rect width="30" height="30" rx="15" fill="#83868A" />
      <circle cx="15" cy="11" r="5" fill="#F4F5FA" />
      <circle cx="15" cy="29" r="11" fill="#F4F5FA" />
    </g>
    <defs>
      <clipPath id="clip0_40002927_18004">
        <rect width="30" height="30" rx="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
